import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { AutoBonusCarTypesPort } from "../../../app/ports/integration/auto-bonus-car-types.port";
import { AutoBonusCarTypeResponse } from "../../../domain/models/integration/auto-bonus-car-types.model";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isAutoBonusCarTypesResponse } from "../../validators/integration/auto-bonus-car-types.validator";

@Injectable()
export class AutoBonusCarTypesHttpAdapter implements AutoBonusCarTypesPort {
  private static readonly CAR_TYPES_PATH = "/api/v1/auto-bonus/car-types";

  constructor(
    private readonly http: HttpClient,
    @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration,
  ) {}

  getCarTypes(): Observable<readonly AutoBonusCarTypeResponse[]> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");

    return this.http.get<unknown>(
      `${baseUrl}${AutoBonusCarTypesHttpAdapter.CAR_TYPES_PATH}`,
    ).pipe(
      map((response) => {
        if (!isAutoBonusCarTypesResponse(response)) {
          throw new Error("La respuesta de tipos de auto es inválida.");
        }
        return response;
      }),
    );
  }
}
